module.exports = {
  headline: 'Your privacy & integrity matters with Spotin',
  index: [

  ],
  terms: `
    <p>
    This Privacy and Integrity Policy has been updated by Spotin AB the 22th of February 2023.
    </p>

    <span>
    1.1
    </span> 
    <p class="m-list">
    Spotin AB protects Customers' integrity and always strive to safeguard your personal data. It is Spotin AB:s goal to follow all laws and regulations regarding privacy and integrity as applicable from time to time. Spotin AB are responsible for ensuring that these Terms and Conditions and the processing of personal data are compliant with the European Union’s (EU’s) General Data Protection Regulation ("<strong>GDPR</strong>").
    </p>

    <span>
    1.2
    </span>
    <p class="m-list">
    Spotin AB (Org. nr: 559027-1549) Rådstugatan 7A, 972 38 Luleå, Sweden, is a controller of personal data for Spotin AB’s handling of the personal data that Customers provide through the service SPOTIN.
    </p>

    <span>
    1.3
    </span>
    <p class="m-list">
    If Spotin AB detects that Customer’s private data has been handled in conflict with applicable laws and regulations Spotin AB undertakes to act within 72h from the conflict has been detected to correct the incorrect handling of the data.
    </p>

    <span>
    1.4
    </span>
    <p class="m-list">
    Spotin AB is controlling data about orders that Customers are providing to SPOTIN, e.g. name, contact details and address, to be able to mediate these to selling parties within Customers' orders. By using SPOTIN data may also come to be collected by service providers where Spotin AB are not complicit neither as data controller nor processor, e.g. in case purchase history is registered by a payment service provider in relation to a purchase. The Customer is referred to the respective service provider's Terms and Conditions for information regarding their processing of data.
    </p>

    <span>
    1.5
    </span>
    <p class="m-list">
    No sensitive data such as described within GDPR are processed within SPOTIN. The Customer himself/herself is responsible for safeguarding protected address information and its suitability for use within SPOTIN.
    </p>

    <span>
    1.6
    </span>
    <p class="m-list">
    Personal data that is no longer required to fulfill laws, rules and agreements, e.g. by business transactions, are removed by SPOTIN.
    </p>

    <span>
    1.7
    </span>
    <p class="m-list">
    Spotin AB processes Customer's personal data to be able to administer the Customer's orders via SPOTIN. The Customer’s personal data will therefore be forwarded to the Seller(s) and the Payment Provider selected by the Customer when necessary to carry out the order and to facilitate the Customer’s purchase. Information about respective Seller's and Payment Provider’s processing of the personal data and/or integrity policy is provided to the Customer at the time of entering an Agreement with respective Seller.
    </p>

    <span>
    1.8
    </span>
    <p class="m-list">
    The Customer’s personal data may be used by Spotin AB for identification of the Customer when an order is placed, or when registering a user within Spotin, administration of orders and business transactions against Sellers. Statistical data may be used in limited scope for statistical purposes without relationship to specific users (e.g. sales data for geographical markets).
    </p>

    <span>
    1.9
    </span>
    <p class="m-list">
    If the Customer gives specific consent personal data may come to be used by Spotin AB for direct marketing via SPOTIN from partnering companies to Spotin AB. E.g. tailored offers from Sellers and Media partners to Spotin AB.
    </p>

    <span>
    1.10
    </span>
    <p class="m-list">
    Spotin AB's processing of personal data may include joint operation with other internal registers within Spotin AB's group of companies. Customer’s personal data may be transferred to other companies within Spotin AB's group both within and outside of EU. Transfer of personal data to other companies within Spotin AB's group requires that the company obeys the same laws and rules for processing personal data is upheld by EU, i.e. fulfillment of GDPR.
    </p>

    <span>
    1.11
    </span>
    <p class="m-list">
    Customers have the right to request information about the personal data that is stored by SPOTIN. A signed request be provided to Spotin AB by the Customer to retrieve the requested information. The request shall be in written form and shall not be sent via e-mail. In case that personal data is stored or processed in a way that is in conflict with applicable laws and regulations the Customer has the right to request that the information is corrected or removed. Removal of data is possible provided that 1.12 below is also fulfilled.
    </p>

    <span>
    1.12
    </span>
    <p class="m-list">
    Removal of personal data can be made as long as the information is not required to follow the responsibilities demanded by applicable laws, rules and agreements. For example, information that is required by Spotin AB, Sellers and Payment Supplier to fulfill the Customer’s order.
    </p>

    <span>
    1.13
    </span>
    <p class="m-list">
    Spotin stores personal data (order data) for a maximum of five (5) years, and only as long as is needed to fulfill §44 and Chapter V of the EU legislations for the prevention of money laundry.
    </p>

    <span>
    1.14
    </span>
    <p class="m-list">
    In case of concerns or complaints to the processing of personal data performed by Spotin AB the Customer has the right to file a complaint to the local authority to which the Customer belongs to. Within Sweden complaints can be filed to the Swedish Authority for Privacy Protection 'Integritetsskyddsmyndigheten' (IMY). 
    </p>

    <span>
    1.15
    </span>
    <p class="m-list">
    For questions or concerns relating to privacy and/or data protection relating to the use of Spotin please contact Spotin's Data Protection Officer (DPO) at <a href="mailto:privacy@spotin.com" style="text-decoration:underline; color:#0048FF">privacy@spotin.com</a>.
    </p>
  `,
};



// WEBPACK FOOTER //
// ./pages/content/privacy_EN.js